export const isValidAge = (
  age: number | null,
  min: number,
  max: number,
): boolean => age !== null && age >= min && age <= max;

export const isValidTimeline = (
  timeline: number | null,
  age: number | null,
): boolean => {
  if (!timeline || timeline < 10) {
    return false;
  }

  if (age !== null && timeline + age > 63) {
    return false;
  }

  return true;
};

export const isValidGoalAmount = (value: number | null): boolean => {
  const minGoal = 1000;
  const maxGoal = 100000000;

  return value !== null && value >= minGoal && value <= maxGoal;
};

export const isValidAgeEnd = (
  ageStart: number | null,
  ageEnd: number | null,
  minAge: number,
  maxAge: number,
): boolean => {
  const minAgeEnd = ageStart !== null ? ageStart + 1 : minAge;
  const maxAgeEnd = maxAge;

  return ageEnd !== null && ageEnd >= minAgeEnd && ageEnd <= maxAgeEnd;
};

export const isValidMonthlyExpenses = (
  value: number | null,
  minValue: number,
  maxValue: number,
): boolean => {
  return value !== null && value >= minValue && value <= maxValue;
};

export const isValidEmergencyFund = (
  value: number | null,
  minValue: number,
  maxValue: number,
): boolean => {
  return value !== null && value >= minValue && value <= maxValue;
};
